<section class="flex justify-content-center mt-4">
    <div class="card-table col-12">
        <div>
            <h1 class="font-roboto-condensed font-23 title-blue text-uppercase font-normal mb-0">{{'msg.actividadesAsociadasPQRSD' | translate}}</h1>
        </div>
        <div>
            <p class="color-general-blue">{{title}}</p>
        </div>
        <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)" class="w-full">
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">                                             
                        <i class="pi pi-history"></i>
                        <span>
                            {{'common.actividadVigente' |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-seguimiento [actividadId]="actividadId" [solicitudId]="solicitudId"></app-seguimiento>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">                                             
                        <i class="pi pi-user"></i>
                        <span>
                            {{'common.informacionCiudadano' |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-cuidadano [solicitudId]="solicitudId"></app-cuidadano>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">                                             
                        <i class="pi pi-file"></i>
                        <span>
                            {{'common.historialDelPqrsd' |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-solicitud-historial [solicitudId]="solicitudId"></app-solicitud-historial>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>